// extracted by mini-css-extract-plugin
export default {"features":"SomeFeatures_features__cehL7","features__svg":"SomeFeatures_features__svg__knyFF"};